import {
  issue__EventType,
  Participant,
} from "@medbillai/generated-graphql-types";

import type { ChatEvent } from "./types";

export const LOADING_AI_RESPONSE_TIMEOUT_MS = 45_000; // 45 seconds

const LOADING_AI_RESPONSE_EVENT_ID_PREFIX = "loading-ai-response";

export const getLoadingAiResponseEventId = (issueId: string) =>
  `${LOADING_AI_RESPONSE_EVENT_ID_PREFIX}-${issueId}`;

export const isLoadingAiResponseEvent = (eventId: string, issueId: string) =>
  eventId === getLoadingAiResponseEventId(issueId);

export const createLoadingAiResponseEvent = (issueId: string): ChatEvent => ({
  __typename: "issue__ChatEvent_Type",
  id: getLoadingAiResponseEventId(issueId),
  eventType: issue__EventType.CHAT,
  participant: Participant.SERVICE,
  sentAt: new Date().toISOString(),
  chatBody: "",
  userVisible: true,
  sentByProfile: null,
  eventFeedbacks: [],
});
